import { datadogRum } from "@datadog/browser-rum";
import { flagIsEnabled, getEnvironmentName, FLAG_NAMES } from "lib/environment";

export function initializeDataDog() {
  if (flagIsEnabled(FLAG_NAMES.DATADOG_RUM_ENABLED)) {
    datadogRum.init({
      applicationId: "26cbd9f7-5e2e-4069-b924-815c38715db7",
      clientToken: "pubd0bddafc136efd4abfe9dd7d110ae034",
      site: "datadoghq.com",
      service: "wisteria-wombat-fe",
      env: getEnvironmentName(),
      version: process.env.REACT_APP_GIT_SHA,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 0,
      traceSampleRate: 100,
      allowedTracingUrls: [
        {
          match: /https?:\/\/.*justworks\.com(:\d+)?\/?.*/,
          propagatorTypes: ["tracecontext", "datadog"],
        },
      ],
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: "mask",
      actionNameAttribute: "data-pii-mask",
      enablePrivacyForActionName: true,
    });
  }
}
